<template>
  <div id="app" v-bind:class="`${vista} in-iframe-${inIframe}`">
    <template v-if="isBuscadorConvenios">
      <router-view />
    </template>
    <template v-else>
      <top-bar></top-bar>
      <div class="router-container">
        <wrap-container class="w100 router-container-inner">
          <router-view />
        </wrap-container>
        <legal-text />
        <app-footer v-if="!loading"></app-footer>
      </div>
    </template>
    <lottie-loader v-if="loading" />
  </div>
</template>

<script>
import AppFooter from "@/components/core/AppFooter";
import WrapContainer from "@/components/core/Container";
import TopBar from "@/components/core/TopBar";
import LottieLoader from "@/components/core/LottieLoader";
import LegalText from "@/components/core/LegalText";

export default {
  name: "App",
  components: { TopBar, AppFooter, LottieLoader, WrapContainer, LegalText },
  data() {
    return {
      vista: null,
      inIframe: window.top !== window.self
    };
  },
  computed: {
    loading() {
      return this.$store.state.isLoading;
    },
    isBuscadorConvenios() {
      return (
        this.vista === "buscadorConvenios" ||
        this.vista === "ConveniosByMerchant" ||
        this.vista === "agroErrorBdc"
      );
    }
  },
  mounted() {
    this.$store.watch(
      this.$store.getters.getRoute,
      route => {
        this.vista = route.name;
      },
      { immediate: true }
    );
  }
};
</script>

<style>
@import "./style/base.css";
@import "./style/media.css";
@import "./style/grid.css";

#app {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  margin: auto;
}

.router-container {
  padding-top: 90px;
  padding-left: 17px;
  padding-right: 17px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.in-iframe-true .router-container {
  padding-top: 0 !important;
}

#app.agropaso5 {
  background: linear-gradient(#043263 420px, transparent 420px) no-repeat;
}

/* Estilos globales para cada paso usando la clase con el nombre de la ruta */
#app.gracias {
  background: #043263;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
#app.gracias.in-iframe-true {
  position: relative !important;
}

@media screen and (min-width: 600px) {
  .router-container {
    padding-top: 103px;
  }
}
</style>
